import { queryOptions } from '@tanstack/react-query'
import type { PublicPlanningResponse } from '@gozoki/api-types'
import { gozokiApi } from '../gozokiApi'

export const getPublicPlanning = async (token: string): Promise<PublicPlanningResponse> => {
  const response = await gozokiApi.get<PublicPlanningResponse>('/public/planning', {
    params: { token },
  })
  return response.data
}

export const publicPlanningQueryKeys = {
  all: ['publicPlanning'] as const,
  byToken: (token: string) => ['publicPlanning', token] as const,
}

export const getPublicPlanningOptions = (token: string) =>
  queryOptions({
    queryKey: publicPlanningQueryKeys.byToken(token),
    queryFn: () => getPublicPlanning(token),
    staleTime: 60_000,
    retry: false,
  })
